import { render } from "./ObjetoIntegracaoOrientacao.vue?vue&type=template&id=788f1da9"
import script from "./ObjetoIntegracaoOrientacao.vue?vue&type=script&lang=js"
export * from "./ObjetoIntegracaoOrientacao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__